import { SongUb } from "../../gql/graphql";

export class PreferredSongnumberFinder {
  public findPreferredSongnumber(
    song: SongUb,
    preferredSongbookId: string | undefined,
  ): string | undefined {
    const songNumber =
      song.songnumbers.find((sn) => sn.songbook.id === preferredSongbookId) ??
      song.songnumbers[0];
    return songNumber
      ? songNumber.songbook.mnemonic + songNumber.number
      : undefined;
  }
}
